
var sprite = require("/Users/fizz/side/antd-mobile/node_modules/svg-sprite-loader/lib/web/global-sprite");
var image = "<symbol viewBox=\"0 0 44 44\" id=\"ellipsis\" xmlns:xlink=\"http://www.w3.org/1999/xlink\"> <g> <circle cx=\"21.888\" cy=\"22\" r=\"4.045\"/> <circle cx=\"5.913\" cy=\"22\" r=\"4.045\"/> <circle cx=\"37.863\" cy=\"22\" r=\"4.045\"/> </g> </symbol>";
module.exports = sprite.add(image, "ellipsis");


/*****************
 ** WEBPACK FOOTER
 ** ./components/icon/style/assets/ellipsis.svg
 ** module id = 470
 ** module chunks = 0
 **/